import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

import { SpaceTemplateStoreModule } from '@main-application/inspections/pages/space-template/store/space-template-store.module';
import { IconComponent } from '@ui-components/components/icon/icon.component';
import { InputModule } from '@ui-components/components/input/input.module';
import { RadioButtonModule } from '@ui-components/components/radio-button/radio-button.module';
import { RadioButtonDropdownModule } from '@ui-components/components/radio-button-dropdown/radio-button-dropdown.module';
import { SelectTreeModule } from '@ui-components/components/select-tree/select-tree.module';
import { TableEmptyContentModule } from '@ui-components/components/table-empty-content/table-empty-content.module';

import { SpaceTemplateModalComponent } from './space-template-modal.component';

@NgModule({
  declarations: [SpaceTemplateModalComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSortModule,
    ReactiveFormsModule,
    InputModule,
    RadioButtonDropdownModule,
    TableEmptyContentModule,
    SelectTreeModule,
    RadioButtonModule,
    SpaceTemplateStoreModule,
    IconComponent,
  ],
})
export class SpaceTemplateModalModule {}
